module.exports = __webpack_public_path__ + "img/logo-feature-cgjt.43ff9d68.png";